import { ProductSheetLanguages } from "@tfg/types/constants/language.constants"

import { useGetActiveLanguages } from "~/gen/api"

export const useActiveLanguages = (
  productSheetGroupId: string | undefined
): Record<ProductSheetLanguages, boolean> | undefined => {
  const { data: activeLanguagesData } = useGetActiveLanguages(
    productSheetGroupId ?? "",
    {
      query: {
        enabled: productSheetGroupId !== undefined,
      },
    }
  )

  const activeLanguages = activeLanguagesData?.data?.activeLanguages as
    | Record<ProductSheetLanguages, boolean>
    | undefined

  return activeLanguages
}

export const getActiveLanguagesList = (
  activeLanguages: Record<ProductSheetLanguages, boolean> | undefined
): ProductSheetLanguages[] => {
  if (!activeLanguages) {
    return []
  }
  const languages = Object.keys(activeLanguages) as ProductSheetLanguages[]

  return languages.filter((language) => activeLanguages[language])
}
